<template>
  <article class="library" v-if="data">
    <div class="library-banner" v-show="bannerStatus">
      <lr-link
        :to="item.url"
        class="library-banner-item"
        v-for="(item, index) in data.banners"
        :key="item.title"
        @click="reportClick({ click: 'topbanner', number: index })"
      >
        <img class="item-img" :src="item.banner" @load="checkImg('success')" @error="checkImg('error')" />
      </lr-link>
    </div>

    <tab
      class="library-tab"
      :list="tabList"
      :current="tab"
      @item-click="handleTabChange"
    ></tab>

    <div class="library-section" ref="skill" v-if="data.skills">
      <h1 class="library-section-title">
        高效技巧
        <lr-link
          :to="data.skills.info.url"
          @click="reportClick({ click: 'more', area: 'skill' })"
        >
          查看全部
          <img class="more" src="~/assets/image/icon/more.svg" alt="" />
        </lr-link>
      </h1>

      <div class="library-section-list">
        <article-unit
          class="library-section-item"
          v-for="item in skillsList"
          :data="item"
          :key="item.id"
          showTags
          @click.native="
            reportClick({
              click: 'content',
              area: 'skill',
              keyword: item.post_title || item.title,
              type: item.id,
            })
          "
        ></article-unit>
      </div>
    </div>

    <div class="library-section" ref="career" v-if="data.career">
      <h1 class="library-section-title">职业专题</h1>
      <div class="library-section-list">
        <lr-link
          :to="item.url"
          class="library-section-item library-career-item"
          v-for="item in data.career.list"
          :key="item.id"
          @click="
            reportClick({
              click: 'topic',
              area: 'job',
              keyword: item.name || item.title,
              topic: item.id,
            })
          "
        >
          <img :src="item.thumbnail" />
          <div class="library-career-item-content">
            <h2 class="library-career-item-title">{{ item.name }}</h2>
            <p class="library-career-item-text ellipsis-2">
              {{ item.brief }}
            </p>
          </div>
        </lr-link>
      </div>
    </div>

    <div class="library-section" ref="about" v-if="data.knows">
      <div class="library-section-title">
        <span>了解WPS</span>
        <lr-link
          :to="data.knows.info.url"
          @click="reportClick({ click: 'more', area: 'wps' })"
        >
          查看全部
          <img class="more" src="~/assets/image/icon/more.svg" alt="" />
        </lr-link>
      </div>
      <div class="library-section-list">
        <article-unit
          class="library-section-item"
          v-for="item in data.knows.list"
          :data="item"
          :key="item.id"
          showTags
          @click.native="
            reportClick({
              click: 'content',
              area: 'wps',
              keyword: item.post_title || item.title,
              type: item.id,
            })
          "
        ></article-unit>
      </div>
    </div>
  </article>
</template>

<script>
import Tab from '@/components/page-tab';
import ArticleUnit from '@/components/article-unit';
import mixinAsyncData from '@/common/mixin/mixin-async-data';
import { isEleVisible, debounce } from '@/common/utils';
import { FOOTER_HEIGHT } from '@/common/constant';

async function asyncData({ app }) {
  const res = await app.$service.learning.getLibraryIndexTotal();
  const data = res && res.data;

  return { data };
}

const tabList = [
  {
    name: '高效技巧',
    value: 'skill',
  },
  {
    name: '职业专题',
    value: 'career',
  },
  {
    name: '了解WPS',
    value: 'about',
  },
];

export default {
  head() {
    let header = this.$head.libraryHead();
    return header;
  },

  data() {
    return {
      banners: [],

      tab: 'skill',
      tabList,

      data: null,
      imgStatusList: [],
    };
  },

  components: {
    Tab,
    ArticleUnit,
  },

  mixins: [mixinAsyncData(asyncData)],

  computed: {
    bannerStatus() {
      if (this.imgStatusList.length === 4) {
        return !this.imgStatusList.find((item) => item === 'error');
      }else{
        return false
      }
    },

    skillsList(){
      const { data } = this
      if(data && data.skills.list.length > 6 ){
        return data.skills.list.slice(0,6)
      }else{
        return data && data.skills.list || []
      }

    }
  },

  methods: {
    handleTabChange(tab) {
      this.tab = tab;
      // 计算需要加上顶部的高度
      const scrollTop = this.$refs[tab].offsetTop - 102;
      window.scrollTo(0, scrollTop);
    },

    /**
     * 上报点击
     */
    reportClick({ click, area, number, keyword, type, topic }) {
      this.$collect.skillarticleHomepageClick({
        click,
        area,
        number,
        keyword,
        type,
        topic,
      });
    },

    /**
     * 上报展示
     */
    reportShow({ show, area, view }) {
      const { data } = this;
      const isShowBanner = data?.banners?.length;

      this.$collect.skillarticleHomepageShow({
        topbanner: isShowBanner ? 'yes' : 'no',
        show,
        area,
        view,
      });
    },

    /**
     * 处理滚动下的展示上报
     */
    handleScroll() {
      const rect = document.body.getBoundingClientRect();
      const { innerHeight: windowHeight } = window;
      const scrollTop = Math.abs(rect.top);
      const skill = this.$refs.skill;
      const career = this.$refs.career;
      const about = this.$refs.about;

      // 假如技巧可见
      if (
        !this._isSkillShow &&
        isEleVisible({ ele: skill, windowHeight, scrollTop })
      ) {
        this._isSkillShow = true;
        this.reportShow({ area: 'skill' });
      }
      // 假如职业专题可见
      if (
        !this._isCareerShow &&
        isEleVisible({ ele: career, windowHeight, scrollTop })
      ) {
        this._isCareerShow = true;
        this.reportShow({ area: 'job' });
      }
      // 假如了解WPS可见
      if (
        !this._isAboutShow &&
        isEleVisible({ ele: about, windowHeight, scrollTop })
      ) {
        this._isAboutShow = true;
        this.reportShow({ area: 'wps' });
      }

      // 到达底部时
      if (!this._isScrollBottom && rect.bottom - innerHeight <= FOOTER_HEIGHT) {
        this._isScrollBottom = true;
        this.reportShow({ view: 'yes' });
      }
    },

    afterMounted() {
      if (!this.data) { // 不存在数据则跳回首页
        this.$router.push('/learning')
      }
      this.reportShow({ show: 'homepage' });

      // 滑动相关的上报
      this.handleScroll();

      this.debounceHandleScroll = debounce(this.handleScroll, 300);
      window.addEventListener('scroll', this.debounceHandleScroll);
    },

    checkImg(status) {
      this.imgStatusList.push(status);
    },
  },

  destroyed() {
    window.removeEventListener('scroll', this.debounceHandleScroll);
  },
};
</script>

<style lang="scss" scoped>
.library {
  margin-top: 6px;
  padding: 0 12px;
  &-tab {
    margin-bottom: 51px;
  }

  &-banner {
    display: flex;
    justify-content: space-between;
    margin-bottom: 56px;

    &-item {
      display: block;
      width: 283px;
      height: 100px;
      border-radius: 8px;

      .item-img {
        display: block;
        width: 100%;
        height: 100px;
        border-radius: 8px;
        object-fit: cover;
      }
    }
  }

  &-section {
    display: block;

    &:not(:last-child) {
      margin-bottom: 51px;
    }

    &-title {
      @include section-title-style();
      margin-bottom: 20px;
      font-size: 20px;
      font-weight: bold;
      color: #111317;
      line-height: 24px;

      > a {
        font-size: 12px;
        color: #6D7582;
        line-height: 20px;
        padding: 2px 4px;
        border-radius: 4px;
        @include flex-align-center();
        font-weight: normal;
        box-sizing: content-box;

        &:hover {
          background: rgba(8, 48, 93, 0.04);
        }

        &:active:not(:disabled) {
          background: rgba(8, 48, 93, 0.08);
        }

        .more {
          width: 16px;
          height: 16px;
          margin-left: 4px;
        }
      }
    }

    &-list {
      ::v-deep .article-unit {
        width: 591px;
      }
    }

    &-item {
      margin-right: 24px;
      margin-bottom: 24px;
      word-break: break-all;

      &:nth-of-type(2n) {
        margin-right: 0;
      }

      &:nth-last-child(1),
      &:nth-last-child(2) {
        margin-bottom: 0;
      }
    }
  }

  &-career-item {
    position: relative;
    display: inline-block;
    width: 591px;
    height: 205px;
    background: #eff5fd;
    border-radius: 4px;
    word-break: break-all;

    & > img {
      display: block;
      width: 100%;
      height: 100%;
    }

    &-content {
      position: absolute;
      left: 250px;
      top: 50%;
      transform: translateY(-50%);
      width: 255px;
    }

    &-title {
      font-size: 22px;
      font-weight: 600;
      line-height: 30px;
      margin-bottom: 12px;
    }

    &-text {
      max-height: 40px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }

  ::v-deep .tab {
    height: 48px;
    .tab-item {
      background: none;
      border: none;
      height: 100%;
      font-size: 24px;
      line-height: 24px;
      margin-right: 48px;
      width: fit-content !important;

      &::after {
        width: 100%;
        margin-left: 0;
        left: 0;
        height: 4px;
        background: #2C71FA;
      }

      > a {
        color: #6D7582;
      }

      &.active {
        > a {
          font-weight: bold;
          color: #111317;
        }
      }
    }
  }
}
</style>
